import { render, staticRenderFns } from "./UserRoleRow.vue?vue&type=template&id=b4bb45a4&"
import script from "./UserRoleRow.vue?vue&type=script&lang=js&"
export * from "./UserRoleRow.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4bb45a4')) {
      api.createRecord('b4bb45a4', component.options)
    } else {
      api.reload('b4bb45a4', component.options)
    }
    module.hot.accept("./UserRoleRow.vue?vue&type=template&id=b4bb45a4&", function () {
      api.rerender('b4bb45a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/permissions/UserRoleRow.vue"
export default component.exports